import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { store } from "./app/auth/store";
import { Provider } from "react-redux";
// import GTMProvider from "./providers/GTMProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      {/* <GTMProvider> */}
      <App />
      {/* </GTMProvider> */}
    </Provider>
  </React.StrictMode>
);
